import Alpine from 'alpinejs';
import { isMobileDevice } from './GreenRoom/utils';

// The two globals of GreenRoom/context.js the storefront relies on. context.js itself (Tabulator,
// SheetJS, Luxon, air-datepicker, tippy, GreenRoom components) is only bundled in greenroom.js,
// loaded by the GreenRoom layout: it made up ~80% of vendors.js, downloaded on every page.
window.Alpine = Alpine;
window.IsMobileDevice = isMobileDevice();
